import { __assign, __rest } from "tslib";
import React from 'react';
import classnames from 'classnames';
import PlainButtonOrLink from '../PlainButtonOrLink';
import { IconSize } from '../../Icons/IconWrap';
import s from './TextButton.scss';
var TextButton = function (_a) {
    var size = _a.size, noSpaceAround = _a.noSpaceAround, variant = _a.variant, className = _a.className, children = _a.children, IconComponent = _a.icon, iconClassName = _a.iconClassName, props = __rest(_a, ["size", "noSpaceAround", "variant", "className", "children", "icon", "iconClassName"]);
    return (React.createElement(PlainButtonOrLink, __assign({ className: classnames(className, s['root'], s["variant-" + variant], s["size-" + size], noSpaceAround && s['no-space-around'], props.disabled && s['disabled']) }, props),
        IconComponent && (React.createElement(IconComponent, { className: classnames(s['icon'], iconClassName), size: IconSize.SMALLER, disableDefaultColors: true })),
        React.createElement("span", { className: s['content'] }, children)));
};
TextButton.displayName = 'TextButton';
export default TextButton;
//# sourceMappingURL=TextButton.js.map